import { useState } from "react";

import Input from "Components/Admin/Form/Input";

import Checkboxes from "../Checkboxes";

const Question = ({ question, answers }) => {
  const [answer, setAnswer] = useState(answers || []);

  if (question?.type === "text")
    return (
      <Input
        key={question?.id}
        name={`answer[${question?.id}]`}
        label={question?.text}
        placeholder="Digite aqui"
        type="textarea"
        height="200px"
        value={answer}
        onChange={(e) => setAnswer(e.target.value)}
        disabled
      />
    );

  return (
    <Checkboxes
      key={question?.id}
      label={question?.text}
      items={
        question?.options.map((option) => ({
          name: option?.id,
          label: option.text,
        })) || []
      }
      selected={answer}
      setSelected={setAnswer}
      disabled
    />
  );
};

export default Question;
